module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "edit-ship-order"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "edit-ship-order-content"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("orders.shipOrder.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("orders.shipOrder.textHeader")))]), _vm._v(" "), _c('div', {
    staticClass: "edit-ship-order-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-12 col-xs-12 input-shipping"
  }, [_c('div', {
    staticClass: "input-shipping-method edit-ship-order-input"
  }, [_c('label', {
    staticClass: "col-lg-4 col-md-4 col-xs-12 fleft"
  }, [_vm._v(_vm._s(_vm.$t("orders.tableOrder.labelShippingMethod")) + " :")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.order.orderShippingMethod.id),
      expression: "order.orderShippingMethod.id"
    }],
    staticClass: "col-lg-8 col-md-8 col-xs-12 fleft",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.order.orderShippingMethod.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.shippingMethods), function(shippingMethod) {
    return _c('option', {
      key: shippingMethod.id,
      domProps: {
        "value": shippingMethod.id
      }
    }, [_vm._v("\n                                " + _vm._s(shippingMethod.name) + "\n                            ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "input-shipping-reference edit-ship-order-input"
  }, [_c('label', {
    staticClass: "col-lg-4 col-md-4 col-xs-12 fleft"
  }, [_vm._v(_vm._s(_vm.$t("orders.tableOrder.labelShippingReference")) + " :")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.shippingReference),
      expression: "form.shippingReference"
    }],
    staticClass: "col-lg-8 col-md-8 col-xs-12 fleft",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.shippingReference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.shippingReference = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-shipping-comment edit-ship-order-input"
  }, [_c('label', {
    staticClass: "col-lg-4 col-md-4 col-xs-12 fleft"
  }, [_vm._v(_vm._s(_vm.$t("orders.tableOrder.labelShippingComments")) + " :")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.shippingComments),
      expression: "form.shippingComments"
    }],
    staticClass: "col-lg-8 col-md-8 col-xs-12 fleft",
    attrs: {
      "rows": "4",
      "cols": "40"
    },
    domProps: {
      "value": (_vm.form.shippingComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.shippingComments = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-xs-12 fright"
  }, [_c('button', {
    staticClass: "btn btn-client fleft",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideModal();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("actions.cancel")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-client2 fright",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateShipOrder();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("actions.confirm")))])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02ac64d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/actions/EditShipOrder.vue
// module id = 2980
// module chunks = 0